import {NgModule} from "@angular/core";
import {CommonModule} from "@angular/common";
import {RadioComponent} from "./radio.component";
import {TranslateModule} from "@ngx-translate/core";

@NgModule({
  declarations: [RadioComponent],
  imports: [ CommonModule, TranslateModule ],
  exports: [ RadioComponent ],
})
export class RadioModule {}
